/* eslint-disable comma-dangle */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Container } from './styles';

import api from '~/services/api';

export default function UserProfile() {
  const { id } = useParams();
  const [profile, setProfile] = useState('');
  const [challenges, setChallenges] = useState([]);
  const [conquers, setConquers] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [currentLevel, setCurrentLevel] = useState(0);
  const [currentJob, setCurrentJob] = useState('');

  useEffect(() => {
    async function getData() {
      const { data } = await api.get(`educator/user/${id}`);

      setProfile(data.profile);
      setCurrentJob(data.profile.current_job);
      setChallenges(data.challenges);
      setConquers(data.achievements);
      setJobs(data.jobs);
    }

    getData();
  }, [id]);

  async function handleSelectLevel(e) {
    setCurrentLevel(e.target.value);
  }

  async function handleCurrentJob(e) {
    setCurrentJob(e.target.value);
  }

  async function updateUserProfile() {
    try {
      await api.put(`userprofile/${profile.id}`, {
        currentLevel,
        currentJob,
      });
      window.location.reload();
    } catch (error) {
      return toast.error(
        'Erro ao atualizar o perfil, por favor, tente novamente'
      );
    }
  }

  return (
    <Container>
      <div className="profile">
        <h1>Perfil:</h1>
        <p>
          Nome: {profile.first_name} {profile.last_name}
        </p>
        <p>Nível Apollo: {profile.apollo_level}</p>
        <p>Trabalho atual: {profile.current_job}</p>
        <p> Entrou na Plataforma: {profile.created_at}</p>
        <p> Email: {profile.email}</p>
        <p> Nascimento: {profile.birthday}</p>
        <p>
          {' '}
          Local: {profile.city}/{profile.state}{' '}
        </p>
        <p> Nivel Ingles: {profile.english}</p>
        <p> Tempo Programando: {profile.level}</p>
        <p> Texto para ser Tutor: {profile.tutor_description}</p>
        <p> Texto pedindo um Tutor: {profile.disciple_description}</p>
      </div>
      <h1>Alterar Modulo Apollo e Trabalho Atual</h1>
      <div className="update">
        <div>
          <p>Nivel Apollo:</p>
          <select value={currentLevel} onChange={handleSelectLevel}>
            <option value={0} disabled>
              Atualize o Nível
            </option>
            <option value={1}>Iniciante</option>
            <option value={2}>Básico</option>
            <option value={3}>Intermediário</option>
            <option value={4}>Avançado</option>
            <option value={5}>Master</option>
          </select>
          <p>Trabalho Atual:</p>
          <input value={currentJob} type="number" onChange={handleCurrentJob} />
          <button
            type="submit"
            onClick={updateUserProfile}
            disabled={!(currentLevel !== 0 || currentJob !== '')}
          >
            Atualizar
          </button>
        </div>
      </div>
      <h1>Conquistas de Modulos:</h1>:
      <div className="conquer">
        {conquers.map((conquer) => (
          <div className="card">
            <img src={conquer.module.file.url} alt="module" />
            <div>
              <p>Titulo do Modulo: {conquer.module.title}</p>
              <p>Nivel do Modulo: {conquer.module.level.title}</p>
            </div>
          </div>
        ))}
      </div>
      <h1>Vagas Aplicadas:</h1>
      <div className="jobs">
        {jobs.map((job) => (
          <div className="card">
            <img src={job.job.file.url} alt="module" />
            <div>
              <p>Nome da Empresa: {job.company}</p>
              <p>Vaga: {job.job.title}</p>
              <p>Status: {job.status}</p>
            </div>
          </div>
        ))}
      </div>
      <h1>Desafios:</h1>
      <h2>Validos: </h2>
      <div className="challenges">
        {challenges.map((challenge) => {
          if (challenge.status === 'correct') {
            return (
              <div className="card">
                <p> Titulo: {challenge.challenge.title}</p>
                <p> Pergunta: {challenge.challenge.question}</p>
              </div>
            );
          }
        })}
      </div>
      <h2>Em Revisāo:</h2>
      <div className="challenges">
        {challenges.map((challenge) => {
          if (challenge.status === 'processing') {
            return (
              <div className="card">
                <p> Titulo: {challenge.challenge.title}</p>
                <p> Pergunta: {challenge.challenge.question}</p>
              </div>
            );
          }
        })}
      </div>
      <h2>Errados:</h2>
      <div className="challenges">
        {challenges.map((challenge) => {
          if (challenge.status === 'wrong') {
            return (
              <div className="card">
                <p> Titulo: {challenge.challenge.title}</p>
                <p> Pergunta: {challenge.challenge.question}</p>
              </div>
            );
          }
        })}
      </div>
    </Container>
  );
}
